module.exports = __webpack_public_path__ + "static/media/gallery.9907d06a.png";